import React, { useState, useEffect,useRef, useLayoutEffect } from 'react';
import SliderWrapper from 'jd-library/SliderWrapper';
import AnimateOnHover from 'jd-library/AnimateOnHover';
import { connect } from 'react-redux';
import style from './UOMSlider.scss';
import searchStyle from '../search-product/search-product.scss';
import UomProductList from './UomList';
import axios from 'axios';
import noResultStyle from '../../common/NoResultFound/no-result-found.scss';
import config from '../../../config/config';
import CSSTransition from '../../common/transition/Animation';
import ImageIcons from 'jd-library/ImageIcons';
import Modal from 'jd-library/Modal';
import InputWithMovingLabel from 'jd-library/InputWithMovingLabel';
import Button from 'jd-library/Button';
import historyHandler from 'jd-library/historyHandler';
import { checkIfCategoryExists } from '../../actions/products';
import withPortal from 'jd-library/withPortal';
import useInfiniteScroll from 'jd-library/useInfiniteScroll';
import { productCatCapitalize, universalClose } from '../../utills';
import SearchHint from '../../common/search-hint/SearchHint';

const CategorySearchSlider = React.forwardRef((props, ref) => {
	const inputRef = useRef(null);
	const [isSearching, setIsSearching] = useState(true);
	const [searchText, setSearchText] = useState('');
	const [categoryListData, setCategoryListData] = useState([]);
	const [showSlider, updateVisibility] = useState(false);
	const [inputFocus, setInputFocus] = useState(true);
	const [addCategoryModal, setAddCategoryModal] = useState({show: false});
	const [changeCategoryModal, setChangeCategoryModal] = useState({show: false});
	const [catName, setCatName] = useState(''); //Add New Category Text;
	const [comments, setComments] = useState('');
	const [loader, showLoader] = useState(false);
	const [errorText, setErrorText] = useState({
		categoryName: '',
		comments: ''
	});
	console.log(props.deviceData.isIphone);
	let axiosCall = useRef(null);
	let [pageNo, setPageNo] = useState(1);
	let [sliderContRef, setSliderContRef] = useState(null);
	const [isScrolled, setScrolled] = useState(
		typeof document === 'object' && document.scrollingElement.scrollTop > 0
	)
	const isContractor = (props.session?.user?.loggedUser?.subType == 'CONTRACTORV2') || (props.session?.user?.loggedUser?.subType == 'CONTRACTORV3')
	useEffect(() => {
		//On opening the slider, search by category if present else name
		if(props.catSliderShown){
			attachClasses();
		}
		getData((props.keywordName || props.categoryName || props.productName ), (res) => {
				updateVisibility(true);
		});
	},[]);
	const attachClasses = () => {
		document.documentElement.classList.add('height100Per','overflow-hidden');
		document.body.classList.add('height100Per','overflow-auto');
		document.querySelector('.jd-iphone') && (document.querySelector('.add-edit-product.jd-iphone').classList.add('overflowHidden', 'height100vh'));
	}
	const detatchClasses = () => {
		document.documentElement.classList.remove('height100Per','overflow-hidden');
		document.body.classList.remove('height100Per','overflow-auto');
		document.querySelector('.jd-iphone') && (document.querySelector('.add-edit-product.jd-iphone').classList.remove('overflowHidden', 'height100vh'));
	}
	const closeSlider = () => {
		detatchClasses();
		window.history.back();
		//getData('');
	};
	const closeKeypad = () => {
		// inputRef.current.blur();
		setInputFocus(false);
		document.getElementById('searchCategory') && document.getElementById('searchCategory').blur();
	};
	let CategoryList = category => { 
		const onClick = (e, category) => {
			if(props.categoryName && props.keywordId?.toString() != category.keywordId){
				// setChangeCategoryModal({
				// 	show:true,
				// 	originalCatName : props.keywordName || props.categoryName,
				// 	changedCatName : category.name,
				// 	cb : () => {
				// 	}
				// })
				props.onSelectCategory(e, category);
				// window.history.back();
				setTimeout(() => {
					closeSlider();
				},300)
			}else{
				props.onSelectCategory(e, category);
				if(!props.fromBulkUpload){
					closeSlider();
				}
			}
		};
		
		return category.map( (catItem, indx) => {
			return (
				<UomProductList
					key={`${catItem.name}--${indx}`}
					uom={productCatCapitalize(catItem.name)}
					onClick={e => onClick(e, catItem)}
					searchText={searchText}
					subtext={catItem.psv_node_name ? ('in '+catItem.psv_node_name) : null}
				/>
			)
		})
	};

	const onValChange = e => {
		let inputVal = e ? e.currentTarget.value : '';
		setSearchText(inputVal);
		updateVisibility(false);
		//On changes to value, search by value if present else name
		getData(inputVal || props.productName, (res) => {
				updateVisibility(true);
		}, false, 1);
		setPageNo(1);
		if (sliderContRef && sliderContRef.current && sliderContRef.current.scrollTo)
			sliderContRef.current.scrollTo(0, 0);
		// if (!e) {
		// 	inputRef.current.focus();
		// }
	};
	const getData = (inputVal, cb, combineOldData, currentPage) => {
		
		if (axiosCall.current) {
			axiosCall.current.cancel();
		}
		axiosCall.current = axios.CancelToken.source();
		axios.get("/vendorapis/products/product/fetchTemplateProductsBySearchTerm", {
			params: {
				limit: 20,
				page: currentPage ? currentPage : pageNo,
				srchterm: inputVal,
				type: 2,
				sort:'pop',
				token: props.token,
				service: props.oType == 'SERVICE' ? 1 : 0
			},
			cancelToken: axiosCall.current.token
		})
		.then( async res=>{
			if (res.data.length) {
				const data = res.data;
				const newData = data.map((item) => {
					item.keywordId = item.id;
					item.id = item.psv_node_id;

					return item;
				});
				 
				if(!combineOldData){
					setCategoryListData(newData);
				}else{
					setCategoryListData(prevData => prevData.concat(newData));
				}
				setPageNo(pageNo+1);
			}else if (!combineOldData) {
				setCategoryListData([]);
			}
			cb && cb({data:res.data, status: !!res.data.length});
		})
	};



	const [isFetching, setIsFetching] = useInfiniteScroll({
		scrollContainer: sliderContRef,
		loadMoreCB: () => {
			getData(
				searchText || props.productName,
				() => {
					setIsFetching(false);
				},
				true
			);
		},
		threshold: 250,
		useWindow: false,
		deps: [sliderContRef]
	});

	const scrollHandler = e => {
		setScrolled(e.target.scrollTop > 5);
	};

	useEffect(() => {
		
		
		setSearchText(props.keywordName ? productCatCapitalize(props.keywordName) : props.categoryName ? productCatCapitalize(props.categoryName) : '');
	}, [props.catSliderShown]);
	const isMobile = props.deviceData.isMobile ;
	const header = {
		heading: 'Select Category',
		variant: 'secondary',
		rightIcons: [
			{
				className: 'icon-HDRcross',
				onClick: () => {
					universalClose(props.fromSellerDashboard,historyHandler);
					//historyHandler.closeAll();
				}
			}
		],
		raised: isScrolled,
		searchBox: true,
		searchVariant: 'edit',
		showOnlySearch: isMobile || props.fromBulkUpload,
		inputProps: {
			className: style['input-container'],
			leftIconClick: !props.fromBulkUpload && isMobile
				? () => {
						historyHandler.closeCurrent();
				  }
				: props.fromBulkUpload ? props.closeSlider :  () => {},
			leftIconClass: isMobile || props.fromBulkUpload
				? `icon-HDRback ${searchStyle['back-icon']}`
				: 'icon-HDRsearch',
			placeholder: 'Search Category',
			onChange: e => {
				onValChange(e);
			},
			onClear: () => onValChange(),
			val: searchText,
			ref: inputRef
		}
	};
	return (
		<>
			<SliderWrapper
				onHidden={show => {
					detatchClasses();
					props.closeSlider && props.closeSlider();
				}}
				updateScrollContRef={ref => {
					setSliderContRef(ref);
				}}
				onScroll={(e) => { scrollHandler(e) }}
				header={header}
				slider = {{
					className : `${style['search-uom-slider']} ${props.deviceData.isIphone ? style["isIphone"] : ""}`
				}}
			> 
					<div
					className={
						style['search-uom-holder'] +
						' ' +
						+ ' ' + (isMobile ? '': style['isWeb'] + ' ' + noResultStyle['isWeb']) + ' ' + props.customClass
					}
				> 
					{categoryListData.length ? (
						<div
							className={`${style['result-holder']} ${style['category-result-holder']}`}
							onTouchMove={closeKeypad}
						>
							<div className={style['result-list']}>
								{CategoryList(categoryListData)}
							</div>
						</div>
					) : !searchText && !categoryListData.length && !props.hideHintText && (
						<SearchHint
							hintText={props.hintText}
							customClass={props.hintCustomClass}
						/>
					)
					||
					showSlider && (
						<div
							className={
								noResultStyle['no-result-container'] +
								' ' +
								style['no-result-holder']
							}
							onTouchMove={closeKeypad}
						> <div className = {`${
							(inputFocus && props.deviceData.isIphone) ? style['no-result-fixed'] : ''
						} ${style['no-result-product']} ${style['no-result-center']}`} >
							<img
								src={props.fromBulkUpload ? ImageIcons.NO_SEARCH : 'https://image1.jdomni.in/jdomni_email/NoProductFound_1911281253.png'}
								className={noResultStyle['no-result-img']}
							/>
							<h3
								className={
									noResultStyle['no-result-heading']
								}
							>
								No Result Found
							</h3>
							</div>
						</div>
					)}
				</div>  
			</SliderWrapper>
			{addCategoryModal.show && <Modal
				settings= {{
					modalId: 'AddCategoryModal',
					variant: 'action',
					class: style['add-category-modal'],
					modalInsideSlider: true
				}}
				backdropStatic={true}
				onHidden={() => {
					if(addCategoryModal.mode == 'confirm'){
						props.onSelectCategory(null, {name: catName},{comments});
						closeSlider();
					}
					setAddCategoryModal({
						show: false
					})
					setCatName('');
					setErrorText({
						categoryName: '',
						comments: ''
					});
					setComments('');
				}} 
			>
				<Modal.Header>{addCategoryModal.mode == 'add' ? 'Add New Category' : 'Confirm New Category'}</Modal.Header>
				{addCategoryModal.mode == 'add' ? <Modal.CloseIcon iconClass='icon-HDRcross' /> : null}
				<Modal.Body className={style['mgb-20']}>
					<div>
						{addCategoryModal.mode == 'add' ? 
							<div className={style['add-cat-body']}>
								<div className={style['warning-div']}><i className='icon-alertNew'></i>Use this option to suggest a new category for your product only if you were not able to find a suitable category. Your category suggestion will be audited and approved before it goes live.</div>
								<InputWithMovingLabel 
									label='Category Name'
									errorMessage={errorText.categoryName}
									holderClass={style['mgb-20']}
									input={{
										onChange: e => { 
											setCatName(e.currentTarget.value); 
											setErrorText({
												...errorText,
												categoryName: ''
											}) 
										},
										value: catName,
										autoFocus: true,
									}}
								/>
								<InputWithMovingLabel
									label="Comments"
									errorMessage={errorText.comments}
									holderClass={style['mgb-25']}
									input={{
										value: comments,
										type: 'textarea',
										onChange: (e) => {
											setComments(e.currentTarget.value);
											setErrorText({
												...errorText,
												comments: ''
											})
										}
									}}
									as='textarea'
								/>
							</div> : 
							<div className={style['info-msg']}>
								You have suggested to add the category <span className={style['text-bold']}>{catName}</span> for your product. Your category suggestion will be audited and approved before it goes live.
							</div>
						}
						<div className={style['add-category-button-holder']}>
							<Button 
								children={addCategoryModal.mode == 'add' ? 'Add Category' : 'Okay, Got It'}
								size='lg'
								block={true}
								showLoader={loader}	
								onClick={()=>{
									if(addCategoryModal.mode=='add'){
										if(!catName || !comments){
											let errorObj = {
												categoryName: catName ? '' : 'Please Enter Category Name',
												comments: comments ? '' : 'Please Enter Comments'
											};
											setErrorText(errorObj);
											props.showToastMessage && props.showToastMessage({
												showToastMessage: true,
												message: catName ? 'Please Enter Comments' : 'Please Enter Category Name',
												type: 'error',
												duration: 5000,
												className: style['z-index-10002']
											});
											return;
										}
										showLoader(true);
										checkIfCategoryExists(catName,props.session.token,(res)=>{
											showLoader(false);
											if(res){
												setErrorText({
													categoryName: 'Entered Category Already Exists'
												})
												props.showToastMessage && props.showToastMessage({
													showToastMessage: true,
													message: 'Entered Category Already Exists',
													type: 'error',
													duration: 5000,
													className: style['z-index-10002']
												});
											}else{
												setAddCategoryModal({
													show: true,
													mode: 'confirm'
												})
											}
										})
									}else{
										historyHandler.closeCurrent();
									}
								}}
							/>
						</div>
					</div>
				</Modal.Body>
			</Modal>}
			{changeCategoryModal.show &&
				<ConfirmCategoryModal 
					changeCategoryModal = {changeCategoryModal}
					setChangeCategoryModal = {setChangeCategoryModal}
					isWeb = {!props.deviceData.isMobile}
				/>
        	}
		</>
	);
});

const ConfirmCategoryModal = withPortal((props) => {
	const {
		changeCategoryModal,
		setChangeCategoryModal,
		isWeb
	} = props
    return(
        <Modal 
			onHidden={() => setChangeCategoryModal({show:false})}
			backdropStatic
			settings={{variant:'action change-category-modal',class : 'change-category-modal' + ' ' + (isWeb ? 'isWeb' : '')}}>
			<Modal.CloseIcon />
			<Modal.Header className='change-category-modal-header'>
				Change Category
			</Modal.Header>
			<Modal.Body className='change-category-modal-body'>
				<div>Changing category will remove all specifications of the previous category - <span className='change-category-highligth'>{changeCategoryModal.originalCatName}</span>. Are you sure you want to change category to <span className='change-category-highligth'>{changeCategoryModal.changedCatName}</span>?</div>
			</Modal.Body>
			<Modal.Footer className='change-category-modal-footer'>
				<Button size='lg' block clickHandler={() => {
					changeCategoryModal.cb && changeCategoryModal.cb()
				}}>Confirm</Button>
			</Modal.Footer>
		</Modal>
    )
})

const mapStateToProps = (state, props) => {
	return {
		token: state.session.token,
		...props,
		deviceData: state.deviceData,
		session: state.session,
		keywordId: state.products.editProduct?.keywordId,
		fromSellerDashboard: state.products.fromSellerDashboard,
	};
};

export default connect(mapStateToProps, null, null, { forwardRef: true })(
	CategorySearchSlider
);
